<style scoped>
.v-application .display-2 {
  font-size: 2.2rem !important;
  font-family: "Prompt", sans-serif !important;
}
.v-application .display-1 {
  font-size: 1.8rem !important;
  font-family: "Prompt", sans-serif !important;
}
.v-application .headline {
  font-size: 1.2rem !important;
  font-family: "Prompt", sans-serif !important;
}
</style>

<template>
  <div>
    <menuBar></menuBar>
    <v-layout class="mx-6 mb-n5">
      <v-row class="mb-n3">
        <v-col cols="12" lg="2">
          <v-select :items="items" label="เลือกปี" dense outlined></v-select>
        </v-col>
        <v-col cols="12" lg="2">
          <v-select label="เขต" dense outlined></v-select>
        </v-col>
        <v-col cols="12" lg="2">
          <v-select label="จังหวัด" dense outlined></v-select>
        </v-col>
        <v-col cols="12" lg="2">
          <v-select label="อำเภอ" dense outlined></v-select>
        </v-col>

        <v-col cols="12" lg="2">
          <v-btn color="white pa-5" elevation="3">
            <v-icon left>mdi-magnify</v-icon>ค้นหา
          </v-btn>
        </v-col>
      </v-row>
    </v-layout>

    <v-layout class="mx-6">
      <v-row>
        <v-col cols="12" lg="6">
          <v-card>
            <v-container>
              <v-card-text>
                <v-row align="center" class="my-n2">
                  <v-col cols="12">
                    <BarChart :styles="myStyles" :Labels="label1" :DataSet="dataset1"></BarChart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6">
          <v-card>
            <v-container>
              <v-card-text>
                <v-row align="center" class="my-n2">
                  <v-col cols="12"></v-col>
                </v-row>
              </v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">พื้นที่</th>
                      <th class="text-left">ปริมาณมูลฝอยติดเชื้อ (ตัน)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>เชียงใหม่</td>
                      <td>5881</td>
                    </tr>
                    <tr>
                      <td>ลำปาง</td>
                      <td>3542</td>
                    </tr>
                    <tr>
                      <td>ลำพูน</td>
                      <td>3633</td>
                    </tr>
                    <tr>
                      <td>เชียงราย</td>
                      <td>2140</td>
                    </tr>
                    <tr>
                      <td>แพร่</td>
                      <td>4458</td>
                    </tr>
                    <tr>
                      <td>แม่ฮ่องสอน</td>
                      <td>2952</td>
                    </tr>
                  </tbody>
                  <v-spacer></v-spacer>
                </template>
              </v-simple-table>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </div>
</template>

<script>
import menuBar from "../components/menuBar";
import Doughnut from "../components/DoughnutChart";
import BarChart from "../components/BarChart";
export default {
  name: "DrillDown",
  components: {
    menuBar,
    Doughnut,
    BarChart,
  },

  data() {
    return {
      items: ["2563", "2564", "2565", "2566"],
      label1: ["เชียงใหม่", "ลำปาง", "ลำพูน", "เชียงราย", "แพร่", "แม่ฮ่องสอน"],
      dataset1: [{
        label: "ปริมาณมูลฝอยติดเชื้อ",
        backgroundColor: "#1E88E5",
        data: [5881,3542 , 3633, 2140, 4458, 2952],
      }],
      height: 340,
    };
  },
  computed: {
    lineStyle() {
      return {
        "background-color": "grey",
      };
    },
    myStyles() {
      return {
        height: `${this.height}px`,
        position: "relative",
      };
    },
  },
  methods: {},
};
</script>
